import type { Schema_Anschrift } from 'cpool-schemas';

type AddressValues = Partial<Record<keyof Schema_Anschrift, unknown>> | null | undefined;

export const hasPreviousAddress = (address: AddressValues) =>
    Object.values(address ?? {}).some((value) => (typeof value === 'string' ? value.trim() !== '' : value != null));
